import svgUrl from "ni:svgr;btJVL8MWo6P7aDMd2-vst58cG0AIBikOSzcPy1QQkBg";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const UiSearchLookalikeCompanySIcon = props => <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M2 3C2 2.44772 2.44772 2 3 2H7.33333V14H3C2.44772 14 2 13.5523 2 13V3Z" fill="var(--tbl--colors--icons--enrich--tertiary)" /><path d="M8.66667 2H13C13.5523 2 14 2.44772 14 3V13C14 13.5523 13.5523 14 13 14H8.66667V2Z" fill="var(--tbl--colors--icons--enrich--primary)" /></svg>;
const Memo = memo(UiSearchLookalikeCompanySIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "ui-node-icon(UiSearchLookalikeCompanySIcon)";
}